let submit_button = document.querySelector('.mail-submit-btn')
let spinner = document.querySelector('.spinner-div')
submit_button.addEventListener('click', () => {
    spinner.classList.toggle('hide')
    spinner.classList.toggle('show')
})
submit_button.addEventListener('focusout', () => {
    spinner.classList.toggle('hide')
    spinner.classList.toggle('show')
})
export default self
